module.exports = __webpack_public_path__ + "static/media/Rectangle 1.082f624b.png";